import { defineComponent as _defineComponent } from 'vue'
import EndControl from '../../RoomFooter/EndControl';
import SwitchCamera from './SwitchCamera.vue';
import SwitchMirror from './SwitchMirror.vue';
import SwitchAudioRoute from './SwitchAudioRoute.vue';
import RoomInfo from '../RoomInfo';
import SwitchTheme from '../../common/SwitchTheme.vue';
import { isWeChat } from '../../../utils/environment';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


return { __sfc: true,EndControl, SwitchAudioRoute, RoomInfo, SwitchTheme, isWeChat }
}

})